import Styles from './Spinner.module.css';
import { useMemo } from 'react';

/** Props for the Spinner component. */
interface ISpinnerDTO {
  classNameContainer?: string;
  classNameRing?: string;
}

/**
 * A loading spinner control.
 *
 * Layout and animation are handled internally via CSS modules. Theming (color, size overrides) is supplied by the consumer via classNameContainer.
 *
 * @param props - Component props.
 * @returns A spinning ring element.
 */
export function Spinner(props: ISpinnerDTO) {
  const { classNameContainer, classNameRing } = props;

  // Compute class names
  const containerClassName = useMemo(() => (classNameContainer ? `${Styles.container} ${classNameContainer}` : Styles.container), [classNameContainer]);
  const ringClassName = useMemo(() => (classNameRing ? `${Styles.ring} ${classNameRing}` : Styles.ring), [classNameRing]);

  // Render Spinner element
  return (
    <div className={containerClassName}>
      <span className={ringClassName} />
    </div>
  );
}
